export default {
	computed: {
		help_items() {
			return [
				{
					route_name: 'article',
					items: [ 
						{
							text: 'Crear articulo',
							url: 'https://youtu.be/rIQWCw_yUZY'
						},
						{
							text: 'Definir el Precio Final de un articulo',
							url: 'https://youtu.be/si3bPMMEct4'
						},
						{
							text: 'Actualizar articulos',
							url: 'https://youtu.be/x9ZbcD71CpQ'
						},
						{
							text: 'Filtrar articulos',
							url: 'https://youtu.be/ayzbg4K7Bfo'
						},
						{
							text: '1) Importar Excel desde archivo base',
							url: 'https://youtu.be/u4GTzRAO7NQ' 
						},
						{
							text: '2) Importar Excel ya existente',
							url: 'https://youtu.be/5miDAIAJfEA'
						},
						{
							text: 'Exportar Excel',
							url: 'https://youtu.be/oAus9iOg0LU'
						},
						{
							text: 'Variantes de un articulo',
							url: 'https://youtu.be/VE4S9L6kZ1o'
						},
					]	
				},
				{
					route_name: 'vender',
					items: [ 
						{
							text: 'Crear una Venta',
							url: 'https://youtu.be/N-oSDawDx-o'
						},
						{
							text: 'Vender a un Cliente',
							url: 'https://youtu.be/yqB4opnJQbU'
						},
					]	
				},
				{
					route_name: 'sale',
					items: [ 
						{
							text: 'Ver ventas',
							url: 'https://youtu.be/EQxI7g4V-wg'
						},
						{
							text: 'Ver ventas por fecha',
							url: 'https://youtu.be/Cv4sx2F0Cw4'
						},
						{
							text: 'Cuentas corrientes',
							url: 'https://youtu.be/d5tUF0WbvQY'
						},
					]	
				},
				{
					route_name: 'online',
					items: [ 
						{
							text: 'Recibir un Pedido',
							url: 'https://youtu.be/CvoMhBNU2m8'
						},
						{
							text: 'Procesar Pedido',
							url: 'https://youtu.be/ZTIg71a2Nts'
						},
						{
							text: 'Cancelar Pedido',
							url: 'https://youtu.be/NpWUaqPdUTs'
						},
					]	
				},
				{
					route_name: 'abm',
					items: [ 
						{
							text: 'Como usar esta seccion',
							url: 'https://youtu.be/exEqDDxR2-s'
						},
						{
							text: 'Tienda Online',
							url: 'https://youtu.be/uv85NkjBWIQ'
						},
					]	
				},
			]
		}
	}
}